import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';

@Component({
  selector: 'app-digital-visiting-card',
  templateUrl: './digital-visiting-card.component.html',
  styleUrls: ['./digital-visiting-card.component.css']
})
export class DigitalVisitingCardComponent implements OnInit {
  titles:any;
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: ' the best cost effective way to attract client`s attention.',
      },
      {
        title: 'Share Contact Information Quickly and Easily.',
      },
      {
        title: 'It`s Better for the Environment.',
      },
      {
        title: 'More Creative Leeway',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/Digital_Visiting.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }

  constructor( private title : Title, private router:Router ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
   }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) +' | Resiliencesoft')
  }

}
